import React from 'react'
import { DataGrid } from '../../datagrid/ResponsiveDataGrid';
import CustomToolbar from '../../datagrid/CustomToolbar';
import CustomLoadingOverlay from '../../datagrid/CustomLoadingOverlay';


const ParnterList = ({
    apiRef,
    columns,
    rows,
    error,
    loading,
    handleRowClick,
    columnVisibilityModel
}) => {
    const [pageSize, setPageSize] = React.useState(20);
    return (
        <div style={{ display: 'flex', height: '500px' }}>
            <div style={{ flexGrow: 1 }}>
                <DataGrid
                    apiRef={apiRef}
                    rows={rows ? rows : []}
                    columns={columns}
                    loading={loading}
                    components={{
                      Toolbar: CustomToolbar,
                      LoadingOverlay: CustomLoadingOverlay,
                    }}
                    componentsProps={{
                      toolbar: { fileName: '거래처마스터' },
                    }}
                    onRowClick={handleRowClick}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[5, 10, 20, 50, 100]}
                    pagination
                    columnVisibilityModel={columnVisibilityModel? columnVisibilityModel: []}

                />
            </div>
        </div>
    )
}

export default ParnterList